var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fitting center kortni-jeane-fitting" },
    [
      _c("div", { staticClass: "pre-step" }, [
        _c("h2", { staticClass: "text-center" }, [_vm._v("FIT AND SIZING")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "categories" },
          _vm._l(_vm.categories, function (value, key) {
            return _c(
              "button",
              {
                key: `category-${key}`,
                staticClass: "btn",
                class: { selected: _vm.category === key },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.category = key
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(value) + "\n      ")]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.category !== ""
        ? [
            _vm.questions_to_include[_vm.category].includes("age")
              ? _c(
                  "collapsible",
                  {
                    attrs: {
                      step:
                        _vm.questions_to_include[_vm.category].indexOf("age") +
                        1,
                      label: `Age: <b>${_vm.age}</b>`,
                      has_next:
                        _vm.questions_to_include[_vm.category].indexOf("age") +
                          1 <
                        _vm.questions_to_include[_vm.category].length,
                      max_height: 1080,
                    },
                  },
                  [_c("step_age")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.questions_to_include[_vm.category].includes("height")
              ? _c(
                  "collapsible",
                  {
                    attrs: {
                      step:
                        _vm.questions_to_include[_vm.category].indexOf(
                          "height"
                        ) + 1,
                      label: `Height: <b>${_vm.height}</b>`,
                      has_next:
                        _vm.questions_to_include[_vm.category].indexOf(
                          "height"
                        ) +
                          1 <
                        _vm.questions_to_include[_vm.category].length,
                      max_height: 1080,
                    },
                  },
                  [_c("step_height")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.questions_to_include[_vm.category].includes("weight")
              ? _c(
                  "collapsible",
                  {
                    attrs: {
                      step:
                        _vm.questions_to_include[_vm.category].indexOf(
                          "weight"
                        ) + 1,
                      label: `Weight: <b>${_vm.weight}</b>`,
                      has_next:
                        _vm.questions_to_include[_vm.category].indexOf(
                          "weight"
                        ) +
                          1 <
                        _vm.questions_to_include[_vm.category].length,
                      max_height: 1080,
                    },
                  },
                  [_c("step_weight")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.questions_to_include[_vm.category].includes("band")
              ? _c(
                  "collapsible",
                  {
                    attrs: {
                      step:
                        _vm.questions_to_include[_vm.category].indexOf("band") +
                        1,
                      label: `Band size: <b>${_vm.underbust_size}</b>`,
                      has_next:
                        _vm.questions_to_include[_vm.category].indexOf("band") +
                          1 <
                        _vm.questions_to_include[_vm.category].length,
                      max_height: 1080,
                    },
                  },
                  [_c("step_1")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.questions_to_include[_vm.category].includes("cup")
              ? _c(
                  "collapsible",
                  {
                    attrs: {
                      step:
                        _vm.questions_to_include[_vm.category].indexOf("cup") +
                        1,
                      label: `Cup size: <b>${_vm.cup_size}"</b>`,
                      has_next:
                        _vm.questions_to_include[_vm.category].indexOf("cup") +
                          1 <
                        _vm.questions_to_include[_vm.category].length,
                      max_height: 1080,
                    },
                  },
                  [_c("step_2")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.questions_to_include[_vm.category].includes("shape")
              ? _c(
                  "collapsible",
                  {
                    attrs: {
                      step:
                        _vm.questions_to_include[_vm.category].indexOf(
                          "shape"
                        ) + 1,
                      label: `Shape: <b>${_vm.shapeToDisplayName(
                        _vm.shape
                      )}</b>`,
                      max_height: 2500,
                    },
                  },
                  [_c("step_3")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.questions_to_include[_vm.category].includes("waist_hips")
              ? _c(
                  "collapsible",
                  {
                    attrs: {
                      step:
                        _vm.questions_to_include[_vm.category].indexOf(
                          "waist_hips"
                        ) + 1,
                      label: `Waist: <b>${_vm.waist_size}</b> Hip: <b>${_vm.hip_size}</b>`,
                      has_next:
                        _vm.questions_to_include[_vm.category].indexOf(
                          "waist_hips"
                        ) +
                          1 <
                        _vm.questions_to_include[_vm.category].length,
                      max_height: 3000,
                    },
                  },
                  [_c("step_4")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.questions_to_include[_vm.category].includes("results")
              ? _c(
                  "collapsible",
                  {
                    attrs: {
                      step:
                        _vm.questions_to_include[_vm.category].indexOf(
                          "results"
                        ) + 1,
                      has_next:
                        _vm.questions_to_include[_vm.category].indexOf(
                          "results"
                        ) +
                          1 <
                        _vm.questions_to_include[_vm.category].length,
                      "max-height": 9999,
                    },
                  },
                  [
                    _c("step_5", {
                      attrs: { online_fitting: _vm.online_fitting },
                    }),
                    _vm._v(" "),
                    _vm.fittings ? _c("results") : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }